import { Flex, FlexProps } from '@modusign/design-system';

interface HeaderProps extends FlexProps<'div'> {}

const Header = (props: HeaderProps) => {
  return (
    <Flex
      bg="darkGray700"
      color="white"
      height={['54px', '54px', '66px']}
      justifyContent="space-between"
      left="0"
      top="0"
      whiteSpace="nowrap"
      width="100%"
      zIndex={500}
      {...props}
    />
  );
};

export default Header;
